let routes = [{
    name: 'School Guardian Assign',
    icon: 'grain',
    path: '/school-guardian-assign',
    service:true,
    permission: 'school-create'
}];

export default routes;